import React from 'react';
import {Tree} from './tree';

export default class CategoryMatchingTo extends Tree{

	constructor(props){
		super(props);
		this.titleClick = this.titleClick.bind(this);
	}

	titleClick(e){
		e.preventDefault();
		let id = e.currentTarget.dataset.id;
		this.props.onClick(id);
	}

	renderTitle(node){
		return (
			<span className="tree-node-title" onClick={this.titleClick} data-id={node.id}>
			    <span>{node.title}</span>
		    </span>
		);
	}
}



// WEBPACK FOOTER //
// ./frontend/components/CategoryMatchingTo.js